<template>
  <!-- Just contains the logo justified to the left. -->
  <v-row class="mx-auto justify-center">
    <!-- Logo Goes Here -->
    <v-img
      :src="require('@/assets/logo.png')"
      contains
      class="logo ml-4"
      v-if="!isMobile"
    ></v-img>
    <v-separator />
    <v-btn class="mx-4 mt-auto mb-auto" to="/" variant="text"> Home </v-btn>
    <v-btn class="mx-4 mt-auto mb-auto" to="/staff" variant="text">
      Staff
    </v-btn>
    <v-btn
      class="mx-4 mt-auto mb-auto justify-right"
      to="/press"
      variant="text"
    >
      Press Kit
    </v-btn>
    <v-btn
      class="mx-4 mt-auto mb-auto"
      variant="text"
      target="_blank"
      href="https://www.kickstarter.com/projects/futurecatgames/margin-of-the-strange"
      v-if="!isMobile"
    >
      Kickstarter
    </v-btn>
    <v-btn
      class="mx-4 mt-auto mb-auto"
      variant="text"
      target="_blank"
      href="https://store.steampowered.com/app/2949750/Margin_of_the_Strange/"
      v-if="!isMobile"
    >
      Steam
    </v-btn>
    <v-btn
      class="mx-4 mt-auto mb-auto"
      variant="text"
      target="_blank"
      href="https://discord.gg/n2ZMD4zSJw"
      v-if="!isMobile"
    >
      Discord
    </v-btn>
    <v-btn
      class="mx-4 mt-auto mb-auto"
      variant="text"
      target="_blank"
      href="https://twitter.com/MarginStrange"
      v-if="!isMobile"
    >
      Twitter
    </v-btn>
  </v-row>
</template>

<script>
import useSizing from "@/composables/useSizing";
import { mapState, mapActions } from "vuex";

export default {
  name: "HeaderBar",
  computed: {
    ...mapState(["activePage"]),
    ...mapState(["argPath"]),
  },

  setup() {
    const { isMobile } = useSizing();
    return { isMobile };
  },

  methods: {
    ...mapActions(["setActivePage"]),
    changePage(page) {
      this.setActivePage(page);
    },
    ...mapActions(["setARGPath"]),
    changeARGPath(path) {
      this.setARGPath(path);
    },
  },
};
</script>

<style scoped>
.logo {
  min-width: 128px;
  max-width: 128px;
}
</style>
